import { Doc } from '../_classes/list/doc';

export let Docs: Doc[] = [
  {
    id: 1,
    name: '<Отсутствует>',
    status: true
  },
  {
    id: 2,
    name: 'Справка МСЭ',
    status: true
  }
]



// WEBPACK FOOTER //
// /usr/home/rob/Staxi/client/src/app/_mock/docs.ts